import { createSlice } from "@reduxjs/toolkit";
import {
  getPickupDelivery,
  updatePickupDelivery,
} from "actions/pickupDelivery";

const initialState = {
  loading: false,
  pickupDeliveryItems: [],
  updateLoading: false,
  error: null,
};

export const pickupDeliverySlice = createSlice({
  name: "pickupDelivery",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPickupDelivery.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPickupDelivery.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.pickupDeliveryItems = payload;
      })
      .addCase(getPickupDelivery.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(updatePickupDelivery.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updatePickupDelivery.fulfilled, (state) => {
        state.updateLoading = false;
      })
      .addCase(updatePickupDelivery.rejected, (state, { payload }) => {
        state.updateLoading = false;
        state.error = payload;
      });
  },
});

export default pickupDeliverySlice.reducer;
